module.exports = {
  // backendLink: 'http://104.248.203.173:3003/api/v1',
  backendLink: "https://insights-api.nichepharma.com/api/v1",
  // backendLink: "http://localhost:3003/api/v1",
};
